export interface Product {
  id: string;
  name: string;
  brand: string;
  category: string;
  price: number;
  originalPrice: number;
  discount: number;
  rating: number;
  reviewCount: number;
  image: string;
  description: string;
}

export const CATEGORIES = [
  { id: "all", label: "全部" },
  { id: "smartphone", label: "智慧手機" },
  { id: "tablet", label: "平板" },
  { id: "laptop", label: "筆電" },
  { id: "monitor", label: "顯示器" },
  { id: "audio", label: "音訊" },
  { id: "haircare", label: "美髮" },
  { id: "cleaning", label: "清潔" },
  { id: "other", label: "其他" },
];

export const SORT_OPTIONS = [
  { id: "default", label: "預設排序" },
  { id: "price-asc", label: "價格低→高" },
  { id: "price-desc", label: "價格高→低" },
  { id: "rating", label: "評分最高" },
];

export const PRODUCTS: Product[] = [
  {
    id: "p1",
    name: "iPhone 15 Pro Max 256GB",
    brand: "APPLE",
    category: "smartphone",
    price: 42900,
    originalPrice: 49900,
    discount: 14,
    rating: 4.9,
    reviewCount: 2341,
    image: "https://public.readdy.ai/ai/img_res/3ead379c73284a4f3faea7aa77258a36.jpg",
    description: "鈦金屬機身，A17 Pro 晶片，專業三鏡頭系統",
  },
  {
    id: "p2",
    name: "iPad Air M2 11吋 256GB",
    brand: "APPLE",
    category: "tablet",
    price: 24900,
    originalPrice: 27900,
    discount: 11,
    rating: 4.8,
    reviewCount: 1876,
    image: "https://readdy.ai/api/search-image?query=iPad%20Air%20M2%20slim%20tablet%20with%20Apple%20Pencil%20floating%20on%20clean%20white%20background%2C%20elegant%20minimalist%20product%20photography%2C%20studio%20lighting%2C%20sharp%20edges%2C%20modern%20tech%20aesthetic&width=400&height=500&seq=2&orientation=portrait",
    description: "M2 晶片效能強悍，輕薄機身，全天候電池續航",
  },
  {
    id: "p3",
    name: "MacBook Air M3 15吋",
    brand: "APPLE",
    category: "laptop",
    price: 52900,
    originalPrice: 59900,
    discount: 12,
    rating: 4.9,
    reviewCount: 987,
    image: "https://readdy.ai/api/search-image?query=MacBook%20Air%20M3%20silver%20open%20laptop%20on%20white%20clean%20desk%2C%20side%20angle%20view%20showing%20thin%20profile%2C%20professional%20product%20photography%2C%20minimalist%20white%20background%2C%20premium%20tech%20aesthetic&width=400&height=500&seq=3&orientation=portrait",
    description: "M3 晶片 18 小時電池，零風扇靜音設計",
  },
  {
    id: "p4",
    name: "Sony WH-1000XM5 無線耳機",
    brand: "SONY",
    category: "audio",
    price: 9900,
    originalPrice: 12900,
    discount: 23,
    rating: 4.8,
    reviewCount: 3412,
    image: "https://readdy.ai/api/search-image?query=Sony%20WH-1000XM5%20premium%20over-ear%20wireless%20headphones%20on%20white%20clean%20background%2C%20minimalist%20product%20photography%2C%20matte%20black%20color%2C%20studio%20lighting%20from%20above%2C%20high-end%20audio%20equipment%20aesthetic&width=400&height=500&seq=4&orientation=portrait",
    description: "業界領先主動降噪，30 小時電池，折疊設計",
  },
  {
    id: "p5",
    name: "Dyson Supersonic™ 吹風機",
    brand: "DYSON",
    category: "haircare",
    price: 16900,
    originalPrice: 19900,
    discount: 15,
    rating: 4.7,
    reviewCount: 2156,
    image: "https://readdy.ai/api/search-image?query=Dyson%20Supersonic%20hair%20dryer%20in%20nickel%20black%20color%20on%20pure%20white%20background%2C%20elegant%20product%20photography%2C%20modern%20minimalist%20design%2C%20studio%20lighting%2C%20luxury%20hair%20care%20appliance&width=400&height=500&seq=5&orientation=portrait",
    description: "智慧溫控保護秀髮，快速乾燥，低噪音設計",
  },
  {
    id: "p6",
    name: "Dyson V15 Detect™ 吸塵器",
    brand: "DYSON",
    category: "cleaning",
    price: 22900,
    originalPrice: 27900,
    discount: 18,
    rating: 4.8,
    reviewCount: 1543,
    image: "https://readdy.ai/api/search-image?query=Dyson%20V15%20Detect%20cordless%20vacuum%20cleaner%20nickel%20yellow%20on%20white%20background%2C%20premium%20product%20photography%2C%20minimalist%20clean%20composition%2C%20studio%20lighting%2C%20high-tech%20home%20appliance&width=400&height=500&seq=6&orientation=portrait",
    description: "雷射偵測微塵，LCD 螢幕顯示，60 分鐘使用時間",
  },
  {
    id: "p7",
    name: "LG UltraFine 27吋 4K 顯示器",
    brand: "LG",
    category: "monitor",
    price: 18900,
    originalPrice: 23900,
    discount: 21,
    rating: 4.7,
    reviewCount: 876,
    image: "https://readdy.ai/api/search-image?query=LG%20UltraFine%2027%20inch%204K%20monitor%20thin%20bezel%20on%20white%20desk%2C%20minimalist%20product%20photography%2C%20clean%20white%20background%2C%20modern%20tech%20aesthetic%2C%20professional%20studio%20shot%2C%20premium%20display&width=400&height=500&seq=7&orientation=portrait",
    description: "4K IPS 面板，USB-C 單線充電，廣色域 99% sRGB",
  },
  {
    id: "p8",
    name: "Apple Watch Series 9 GPS 45mm",
    brand: "APPLE",
    category: "other",
    price: 13900,
    originalPrice: 16900,
    discount: 18,
    rating: 4.8,
    reviewCount: 2089,
    image: "https://readdy.ai/api/search-image?query=Apple%20Watch%20Series%209%20midnight%20aluminum%20smartwatch%20with%20sport%20band%20on%20white%20clean%20background%2C%20flat%20lay%20product%20photography%2C%20minimalist%20composition%2C%20professional%20studio%20lighting%2C%20luxury%20wearable%20tech&width=400&height=500&seq=8&orientation=portrait",
    description: "S9 晶片，血氧偵測，18 小時電池，Always-On 顯示",
  },
];
